import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Title1 } from '@ui/Typography'
import { TableEmptyComponent } from '@ui/v2/Table/NoResults/TableNoResults'

import { TMGrayLogo } from '@assets/logo/TMGray.logo'

import styles from './EmptyTransactionHistory.module.scss'

export const EmptyTransactionHistory: FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.emptyTransactionHistory}>
      <TableEmptyComponent />
      <div className={styles.infoWrapper}>
        <TMGrayLogo />

        <Title1 medium>{t('IB.Dashboard.Your transactions will appear here')}</Title1>
      </div>
    </div>
  )
}
